/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryinfotype3Inputs */

const en_medialibraryinfotype3 = /** @type {(inputs: Medialibraryinfotype3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File type`)
};

const de_medialibraryinfotype3 = /** @type {(inputs: Medialibraryinfotype3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateityp`)
};

/**
* | output |
* | --- |
* | "File type" |
*
* @param {Medialibraryinfotype3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryinfotype3 = /** @type {((inputs?: Medialibraryinfotype3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryinfotype3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryinfotype3(inputs)
	return de_medialibraryinfotype3(inputs)
});
export { medialibraryinfotype3 as "mediaLibraryInfoType" }